"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
class TrialsSampleState {
    constructor(numberSamples, state, projectId) {
        this.numberSamples = 0;
        this.allSamples = [];
        this.projectId = null;
        this.loadingAllSamples = false;
        this.isLoadingMarkSamples = false;
        this.callSamplesError = null;
        this.state = {
            id: 0,
            name: '',
            name_formatted: '',
        };
        this.numberSamples = numberSamples;
        this.state = state;
        this.projectId = projectId;
    }
    getNumberSamples() {
        return this.numberSamples;
    }
    getAllSamples() {
        return this.allSamples;
    }
    get loadingMark() {
        return this.isLoadingMarkSamples;
    }
    getLoadingAllSamples() {
        return this.loadingAllSamples;
    }
    get collectResponseMarkSamples() {
        return this.markSamplesSentResponse;
    }
    calculatingPercentage(total, unit) {
        return (100 * unit) / total;
    }
    isDeployActionMarkSent() {
        if (this.state.id === 1)
            return true;
        return false;
    }
    isDeploySubState() {
        if (this.state.id === 2)
            return true;
        return false;
    }
    isFinalState() {
        if (this.state.id === 4)
            return true;
        return false;
    }
    async callAllSamples(projectId, state) {
        this.loadingAllSamples = true;
        try {
            const call = await fetch(`/tracking/project/samples/${projectId}?status=${state}`);
            const data = await call.json();
            this.allSamples = data;
        }
        catch (error) {
            this.callSamplesError = error.message;
        }
        this.loadingAllSamples = false;
    }
    async markSamplesSent(samplesT, projectId) {
        this.isLoadingMarkSamples = true;
        const samples = { samples: samplesT, project_id: projectId };
        try {
            const response = await axios_1.default.post('/data/results/project/sent/samples', samples);
            this.markSamplesSentResponse = response.data.messages;
        }
        catch (e) {
            console.log(e);
        }
        setTimeout(() => {
            this.isLoadingMarkSamples = false;
        }, 2500);
    }
}
exports.default = TrialsSampleState;
